import React from 'react'

export const TextInput = ({ id, type, placeholder, value, onChange, onKeyUp, className }) => {
  return (
    <input id={id} type={type || 'text'} placeholder={placeholder} onChange={onChange} onKeyUp={onKeyUp} value={value} className={className} style={inputStyle} />
  )
}

const inputStyle = {
  width: 325,
  height: 47,
  padding: 0,
  borderRadius: 5,
  border: '1px solid transparent',
  margin: '0.25em 0',
  textAlign: 'center',
  fontSize: 20,
  color: '#322d63',
  maxWidth: '100%',
}

export default TextInput



/** WEBPACK FOOTER **
 ** ./src/components/TextInput.js
 **/